/**
 * //https://www.npmjs.com/package/react-vehicle-keyboard
 */
import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// import CarKeyboard from 'hc-react-keyboard-car'     //https://www.npmjs.com/package/hc-react-keyboard-car
import Keyboard from 'react-vehicle-keyboard'
import BaseComponent from '../../../base/BaseComponent'
// import 'hc-react-keyboard-car/lib/index.less'
require('react-vehicle-keyboard/dist/react-vehicle-keyboard.css')

class VehicleKeyboard extends BaseComponent {
	static propTypes = {
		type: PropTypes.oneOf([1, 2]), //显示键盘的类型 1:省缩写 2:字母和数字
		show: PropTypes.bool,
		onClick: PropTypes.func,
		className: PropTypes.string,
		disabledKeys: PropTypes.array,
		keyClassName: PropTypes.array,
	}

	static defaultProps = {
		type: 1,
		show: false,
		className: '',
		disabledKeys: [],
		keyClassName: [],
		onClick: () => {},
	}

	constructor(props) {
		super(props)
		this.state = {}
	}

	render() {
		const { type, show, className, disabledKeys, keyClassName, onClick } = this.props

		return ReactDOM.createPortal(
			<div className={`${className}`}>
				<Keyboard
					type={type}
					show={show}
					disabledKeys={disabledKeys}
					onClick={onClick}
					keyClassName={keyClassName}
					className={`override-vehicle-keyboard`}
					// carTxt={[
					//     '京',
					//     '津',
					//     '沪',
					//     '渝',
					//     '苏',
					//     '浙',
					//     '豫',
					//     '粤',
					//     '川',
					//     '陕',
					//     '冀',
					//     '辽',
					//     '吉',
					//     '皖',
					//     '闽',
					//     '鄂',
					//     '湘',
					//     '鲁',
					//     '晋',
					//     '黑',
					//     '赣',
					//     '贵',
					//     '甘',
					//     '桂',
					//     '琼',
					//     '云',
					//     '青',
					//     '蒙',
					//     '藏',
					//     '宁',
					//     '新',
					//     '港',
					//     '澳',
					// ]}
				/>
			</div>,
			document.getElementById('app'),
		)
	}
}

export default styled(VehicleKeyboard)`
	.override-vehicle-keyboard {
		.content {
			padding: 0.26rem 0.048rem 0;
			padding-bottom: contant(safe-area-inset-bottom);
			padding-bottom: env(safe-area-inset-bottom);
			background-color: #eaedf1;
			.key {
				color: #000;
				display: flex;
				width: 0.62rem;
				height: 0.82rem;
				box-shadow: none;
				font-size: 0.36rem;
				line-height: normal;
				align-items: center;
				border-radius: 0.14rem;
				margin: 0 0.06rem 0.14rem;
				justify-content: center;

				&.btnClose,
				&.btnConfirm {
					width: 1.4rem;
				}

				&:active {
					background: #cecece;
				}

				&.disabled {
					color: #bcbcbc !important;
					background: #fff !important;
				}
			}
			.btns-container {
				right: 0.048rem;
				bottom: 0;
				bottom: contant(safe-area-inset-bottom);
				bottom: env(safe-area-inset-bottom);
			}
		}
	}
`
